import React, { useState } from 'react';
import excellentFitIcon from '../../Assets/images/review_icons/excellentFit.svg';
import goofFitIcon from '../../Assets/images/review_icons/goodFit.svg';
import moderateFitIcon from '../../Assets/images/review_icons/moderateFit.svg';
import poorFitIcon from '../../Assets/images/review_icons/poorFit.svg';
import { AiOutlineDown, AiOutlineUp } from 'react-icons/ai';
import { Skeleton } from 'antd';

const DynamicAssessment = ({ candidatessementData, isLoading }) => {
  const [isOpen, setIsOpen] = useState(true);
  console.log(
    'candidatessementDatacandidatessementData',
    candidatessementData,
  );
  return (
    <div className="tab:flex block gap-6 w-full mt-6">
      <div className="tab:w-[45%] w-full">
        <div>
          <div className="rounded bg-white">
            <div className="px-8 py-6 flex items-center gap-2">
              <div className="w-[38px] h-[35px] flex items-center justify-center">
                <svg
                  width="42"
                  height="39"
                  viewBox="0 0 42 39"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.5386 37C15.8347 37 12.226 35.8301 9.22962 33.6577C6.23321 31.4855 4.00292 28.4226 2.8584 24.9077C1.71387 21.3931 1.71387 17.6069 2.8584 14.0922C4.00292 10.5774 6.23321 7.51445 9.22962 5.34219C12.226 3.16996 15.8347 2 19.5386 2C23.2422 2 26.8509 3.16996 29.8473 5.34222C32.8437 7.51445 35.0741 10.5775 36.2186 14.0922C37.363 17.6069 37.363 21.3931 36.2186 24.9077M33.6667 21.4445L36.1025 25.3334L40 22.4166M23.4358 13.6667C23.4358 15.8145 21.6909 17.5555 19.5386 17.5555C17.386 17.5555 15.6411 15.8145 15.6411 13.6667C15.6411 11.5189 17.386 9.77779 19.5386 9.77779C21.6909 9.77779 23.4358 11.5189 23.4358 13.6667ZM16.0537 21.4445H23.0232C23.6502 21.4445 23.9636 21.4445 24.2439 21.4893C25.2142 21.6444 26.0533 22.1893 26.5234 22.9698C26.6591 23.1953 26.7583 23.4633 26.9566 23.9992C27.1947 24.6432 27.3138 24.9652 27.3299 25.2249C27.3867 26.141 26.725 26.9683 25.7426 27.2094C25.4641 27.2779 25.0877 27.2779 24.3344 27.2779H14.7426C13.9894 27.2779 13.6127 27.2779 13.3343 27.2094C12.3518 26.9683 11.6902 26.141 11.747 25.2249C11.7631 24.9652 11.8822 24.6432 12.1204 23.9992C12.3186 23.4633 12.4177 23.1953 12.5536 22.9698C13.0236 22.1893 13.8627 21.6444 14.833 21.4893C15.1134 21.4445 15.4267 21.4445 16.0537 21.4445Z"
                    stroke="#70AEB6"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div>
                <h3 className="text-[#000] font-medium">Summary</h3>
                <p className="text-[#5C5C5C] text-xs">
                  Candidate Interview Overview
                </p>
              </div>
            </div>
          </div>
          <div className="rounded bg-[#EFFFFF] p-6">
            {isLoading ? (
              <Skeleton active paragraph={{ rows: 2 }} />
            ) : candidatessementData?.interview_summary ? (
              <p className="text-[#073137] text-sm capitalize leading-7 mt-2 font-poppins">
                {candidatessementData?.interview_summary}
              </p>
            ) : (
              <p className="text-center text-[#000000] font-poppins font-medium">
                No Summary Found
              </p>
            )}
          </div>
          <div className="flex items-center gap-1 py-2 bg-white px-6">
            <svg
              width="13"
              height="14"
              viewBox="0 0 13 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.6008 6.40323V5.80138C10.6008 3.53859 10.6008 2.4069 9.89755 1.70424C9.19429 1.00158 8.0632 1.00098 5.80041 1.00098H5.20516L1 5.19293V8.20519C1 10.4644 1 11.5943 1.70086 12.2969L1.70506 12.3011C2.40772 13.002 3.53762 13.002 5.79681 13.002"
                stroke="#8A8A8A"
                stroke-width="0.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 5.20329H1.60005C3.29699 5.20329 4.14607 5.20329 4.67291 4.67584C5.20036 4.149 5.20036 3.29992 5.20036 1.60298V1.00293M9.04488 12.7615C9.07317 12.8328 9.12222 12.8939 9.18566 12.937C9.24911 12.9801 9.32403 13.0031 9.40071 13.0031C9.4774 13.0031 9.55232 12.9801 9.61576 12.937C9.67921 12.8939 9.72825 12.8328 9.75654 12.7615L9.77874 12.7057C9.93263 12.3156 10.1651 11.9612 10.4616 11.6647C10.7582 11.3681 11.1125 11.1357 11.5027 10.9818L11.5585 10.9596C11.6298 10.9313 11.6909 10.8822 11.734 10.8188C11.7771 10.7553 11.8001 10.6804 11.8001 10.6037C11.8001 10.5271 11.7771 10.4521 11.734 10.3887C11.6909 10.3252 11.6298 10.2762 11.5585 10.2479L11.5027 10.2257C11.1126 10.0719 10.7583 9.83955 10.4617 9.54309C10.1652 9.24664 9.9327 8.8924 9.77874 8.50237L9.75654 8.44656C9.72825 8.37528 9.67921 8.31414 9.61576 8.27107C9.55232 8.22799 9.4774 8.20496 9.40071 8.20496C9.32403 8.20496 9.24911 8.22799 9.18566 8.27107C9.12222 8.31414 9.07317 8.37528 9.04488 8.44656L9.02268 8.50237C8.86879 8.89251 8.63636 9.24687 8.3398 9.54343C8.04323 9.83999 7.68888 10.0724 7.29873 10.2263L7.24293 10.2485C7.17165 10.2768 7.11051 10.3258 7.06743 10.3893C7.02436 10.4527 7.00133 10.5277 7.00133 10.6043C7.00133 10.681 7.02436 10.7559 7.06743 10.8194C7.11051 10.8828 7.17165 10.9319 7.24293 10.9602L7.29873 10.9824C7.68888 11.1363 8.04323 11.3687 8.3398 11.6653C8.63636 11.9618 8.86879 12.3162 9.02268 12.7063L9.04488 12.7615Z"
                stroke="#8A8A8A"
                stroke-width="0.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <span className="text-[#585858] text-sm leading-7 capitalize">
              AI generated
            </span>
          </div>
        </div>
        <div className="bg-white rounded p-6 mt-5">
          <h3 className="text-[#000] font-poppins font-medium">
            Overall Fit Assessment{' '}
          </h3>
          {isLoading ? (
            <Skeleton active paragraph={{ rows: 5 }} className="mt-4" />
          ) : (
            <>
              <div className="w-full flex items-center justify-center my-3">
                {candidatessementData?.overall_fit_assessment == 1 ? (
                  <div>
                    <img src={poorFitIcon} className="w-[73px] h-[98px]" />
                    <p className="text-center text-[#000000] font-poppins font-medium">
                      Poor Fit
                    </p>
                  </div>
                ) : candidatessementData?.overall_fit_assessment == 2 ? (
                  <div>
                    <img
                      src={moderateFitIcon}
                      className="w-[73px] h-[98px]"
                    />
                    <p className="text-center text-[#000000] font-poppins font-medium">
                      Moderate Fit
                    </p>
                  </div>
                ) : candidatessementData?.overall_fit_assessment == 3 ? (
                  <div>
                    <img src={goofFitIcon} className="w-[73px] h-[98px]" />
                    <p className="text-center text-[#000000] font-poppins font-medium">
                      Good Fit
                    </p>
                  </div>
                ) : candidatessementData?.overall_fit_assessment == 4 ? (
                  <div>
                    <img
                      src={excellentFitIcon}
                      className="w-[73px] h-[98px]"
                    />
                    <p className="text-center text-[#000000] font-poppins font-medium">
                      excellent Fit
                    </p>
                  </div>
                ) : (
                  <div>
                    <p className="text-center text-[#000000] font-poppins font-medium">
                      No Result Found
                    </p>
                  </div>
                )}
              </div>
              <div className="rounded-md border border-[#EAEAEA] shadow-[0_4px_4px_0_rgba(224,224,224,0.25)] p-4">
                <p className="text-[#6A6A6A] font-poppins text-sm font-medium leading-7 capitalize">
                  {candidatessementData?.fit_reason}
                </p>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="tab:w-[55%] w-full">
        <div className="">
          <div className="bg-white rounded shadow border-t p-4 space-y-2">
            {isLoading ? (
              <Skeleton active paragraph={{ rows: 2 }} className="mt-4" />
            ) : candidatessementData?.topic_stats?.length > 0 ? (
              <>
                <div
                  onClick={() => setIsOpen(!isOpen)}
                  className="bg-white rounded flex w-full border cursor-pointer"
                >
                  <div className="bg-white p-4 w-1/3 flex items-center justify-center">
                    <div>
                      <p className="text-[#0A7F8F] font-poppins font-semibold">
                        {candidatessementData?.topic_stats?.[0]?.topic}
                      </p>
                      <p className="text-[#3A3939] font-poppins text-[13px] capitalize">
                        Interview Topic
                      </p>
                    </div>
                  </div>

                  <div className="bg-[#F3FFFF] p-4 w-1/3 flex items-center justify-center">
                    <div>
                      <p className="text-[#0A7F8F] font-poppins font-semibold">
                        {
                          candidatessementData?.topic_stats?.[0]
                            ?.questions_asked
                        }
                      </p>
                      <p className="text-[#3A3939] font-poppins text-[13px] capitalize">
                        Questions Asked
                      </p>
                    </div>
                  </div>

                  <div className="bg-[#E2F0F0] p-4 w-1/3 flex items-center justify-center relative">
                    <div>
                      <p className="text-[#0A7F8F] font-poppins font-semibold">
                        {
                          candidatessementData?.topic_stats?.[0]
                            ?.weightage_percentage
                        }{' '}
                        %
                      </p>
                      <p className="text-[#3A3939] font-poppins text-[13px] capitalize">
                        Weightage
                      </p>
                    </div>
                    {isOpen ? (
                      <AiOutlineUp className="text-[#0A7F8F] text-lg absolute top-[2rem] right-[1rem]" />
                    ) : (
                      <AiOutlineDown className="text-[#0A7F8F] text-lg absolute top-[2rem] right-[1rem]" />
                    )}
                  </div>
                </div>
                <div
                  className={`overflow-hidden transition-all duration-500 ease-in-out ${
                    isOpen
                      ? 'max-h-[1000px] opacity-100'
                      : 'max-h-0 opacity-0'
                  }`}
                >
                  {/* {isOpen && ( */}
                  <div className="space-y-2">
                    {candidatessementData?.topic_stats
                      ?.slice(1)
                      .map((card, idx) => (
                        <div
                          key={idx}
                          className="bg-white rounded flex w-full border"
                        >
                          <div className="bg-white p-4 w-1/3 flex items-center justify-center">
                            <div>
                              <p className="text-[#0A7F8F] font-poppins font-semibold">
                                {card.topic}
                              </p>
                              <p className="text-[#3A3939] font-poppins text-[13px] capitalize">
                                Interview Topic
                              </p>
                            </div>
                          </div>

                          <div className="bg-[#F3FFFF] p-4 w-1/3 flex items-center justify-center">
                            <div>
                              <p className="text-[#0A7F8F] font-poppins font-semibold">
                                {card.questions_asked}
                              </p>
                              <p className="text-[#3A3939] font-poppins text-[13px] capitalize">
                                Questions Asked
                              </p>
                            </div>
                          </div>

                          <div className="bg-[#E2F0F0] p-4 w-1/3 flex items-center justify-center">
                            <div>
                              <p className="text-[#0A7F8F] font-poppins font-semibold">
                                {card.weightage_percentage} %
                              </p>
                              <p className="text-[#3A3939] font-poppins text-[13px] capitalize">
                                Weightage
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                  {/* )} */}
                </div>
              </>
            ) : (
              <p className="text-center text-[#000000] font-poppins font-medium">
                No Topics Found
              </p>
            )}
          </div>
        </div>

        <div className="rounded bg-white p-6 mt-5">
          <h3 className="text-[#000] font-poppins font-medium">
            Key Strengths Demonstrated
          </h3>
          {/* {isLoading ? (
            <Skeleton active paragraph={{ rows: 2 }} className="mt-4" />
          ) : (
            <div className="flex items-center justify-center mb-12 mt-9">
              <DynamiPieChart
                value={candidatessementData?.key_strengths_percentage || 0}
              />
            </div>
          )} */}
          {isLoading ? (
            <Skeleton active paragraph={{ rows: 5 }} className="mt-4" />
          ) : candidatessementData?.key_strengths?.length > 0 ? (
            <div className="mt-5">
              {candidatessementData?.key_strengths?.map((strength) => (
                <div className="rounded-md border border-[#EAEAEA] shadow-[0_4px_4px_0_rgba(224,224,224,0.25)] py-3 px-5 flex items-center gap-3 mb-3">
                  <svg
                    width="16"
                    height="15"
                    viewBox="0 0 16 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16 7.49642L14.2255 5.50406L14.4727 2.8667L11.8473 2.27903L10.4727 0L8 1.04634L5.52727 0L4.15273 2.27903L1.52727 2.85953L1.77455 5.49689L0 7.49642L1.77455 9.48877L1.52727 12.1333L4.15273 12.721L5.52727 15L8 13.9465L10.4727 14.9928L11.8473 12.7138L14.4727 12.1261L14.2255 9.48877L16 7.49642ZM6.54545 11.0798L3.63636 8.21309L4.66182 7.20258L6.54545 9.0516L11.3382 4.32871L12.3636 5.34639L6.54545 11.0798Z"
                      fill="#05B491"
                    />
                  </svg>
                  <p className="text-[#737373] font-poppins text-sm font-medium">
                    {strength}
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-center text-[#000000] font-poppins font-medium">
              No Key Strengths Found
            </p>
          )}
        </div>

        <div className="rounded bg-white p-6 mt-5">
          <h3 className="text-[#000] font-poppins font-medium">
            Area for Improvement
          </h3>
          {isLoading ? (
            <Skeleton active paragraph={{ rows: 4 }} className="mt-4" />
          ) : (
            candidatessementData?.areas_for_improvement?.length > 0?
            <div className="mt-5">
              {candidatessementData?.areas_for_improvement?.map(
                (improvement) => (
                  <div className="rounded-md border border-[#FEDBDB] bg-[#FEDBDB] shadow-[0_4px_4px_0_rgba(224,224,224,0.25)] py-3 px-5 flex items-center gap-3 mb-3">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 0C12.4184 0 16 3.5816 16 8C16 12.4184 12.4184 16 8 16C3.5816 16 0 12.4184 0 8C0 3.5816 3.5816 0 8 0ZM8 10.4C7.78783 10.4 7.58434 10.4843 7.43431 10.6343C7.28429 10.7843 7.2 10.9878 7.2 11.2C7.2 11.4122 7.28429 11.6157 7.43431 11.7657C7.58434 11.9157 7.78783 12 8 12C8.21217 12 8.41566 11.9157 8.56569 11.7657C8.71571 11.6157 8.8 11.4122 8.8 11.2C8.8 10.9878 8.71571 10.7843 8.56569 10.6343C8.41566 10.4843 8.21217 10.4 8 10.4ZM8 3.2C7.80405 3.20003 7.61493 3.27196 7.4685 3.40217C7.32207 3.53238 7.22853 3.7118 7.2056 3.9064L7.2 4V8.8C7.20023 9.0039 7.2783 9.20003 7.41828 9.3483C7.55825 9.49656 7.74956 9.58579 7.95312 9.59774C8.15667 9.60969 8.3571 9.54346 8.51347 9.41259C8.66983 9.28172 8.77032 9.09608 8.7944 8.8936L8.8 8.8V4C8.8 3.78783 8.71571 3.58434 8.56569 3.43431C8.41566 3.28429 8.21217 3.2 8 3.2Z"
                        fill="#E15B5B"
                      />
                    </svg>

                    <p className="text-[#BC7979] font-poppins text-sm font-medium">
                      {improvement}
                    </p>
                  </div>
                ),
              )}
            </div>:
            <p className="text-center text-[#000000] font-poppins font-medium">
            No Area of Improvement Found
          </p>
          )}
        </div>
      </div>
    </div>
  );
};
export default DynamicAssessment;
